export default "__VITE_ASSET__bs5X4oJ$__"